export enum QualityType {
    OC = 1,
    BC = 2,
    PUR = 4,
    WBC = 5,
    PURHS = 6
}

